module.exports = "/google_play_button-afe837d1266b90ce8f7d859e2a0c3a7b.svg";